import React, { FC, useCallback } from 'react'

import { TemplateFormProps } from './TemplateForm.props'
import { QuillForm } from 'modulesCommon/Forms/components'

import './TemplateForm.scss'

const TemplateForm: FC<TemplateFormProps> = ({
  template: { template_type, template, id, label_id },
  setTemplateValues
}) => {
  const handleChange = useCallback(
    (value) => {
      setTemplateValues &&
        setTemplateValues((prevState) => ({ ...prevState, [template_type as string]: { value, id, label_id } }))
    },
    [id, label_id, template_type, setTemplateValues]
  )

  return (
    <form className="template-form">
      <QuillForm
        isDisabled={false}
        initialData={template ?? ''}
        onChange={handleChange}
        label=""
        field={template_type ?? ''}
        isMessages
      />
    </form>
  )
}

export default TemplateForm
